<template>
    <div class="creek-playlist" v-if="broadcast && broadcast.relationships.playlist">
      <div class="creek-track" v-for="Track in broadcast.relationships.playlist">
        <span v-if="Track.attributes.start" v-html="fecha.format(fecha.parse(Track.attributes.start, 'YYYY-MM-DD HH:mm:ss'), 'h:mma')" class="creek-track-time"></span>
        <!-- <span v-if="Track.attributes.start" v-html="Track.attributes.start" class="creek-track-time"></span> -->
        <span v-if="Track.attributes.artist" v-html="Track.attributes.artist" class="creek-track-artist"></span>
        <span v-if="Track.attributes.artist && Track.attributes.title" class="creek-track-divide1"> - </span>
        <span v-if="Track.attributes.title" v-html="Track.attributes.title" class="creek-track-title"></span>
        <span class="creek-track-label"><span v-if="Track.attributes.label" class="creek-track-divide1">(</span><span v-if="Track.attributes.label" v-html="Track.attributes.label"></span><span v-if="Track.attributes.label" class="creek-track-divide1">)</span></span>
      </div>
    </div>
</template>

<script type="text/javascript">
export default {
  name: 'creek-playlist',
  props: ['broadcast'],
}
</script>